module.exports = __webpack_public_path__ + "static/media/720x480.9207a118.jpg";